import React, { useState } from "react";
import styled from "styled-components";
import { useSelector } from "react-redux";
import {
  DISPLAY_DATE_FORMAT,
  PAGINATION_DEFAULT_LIMIT,
} from "../../../utilities/constants";
import moment from "moment";
import useConfirmationModal from "../../ConfirmationModal/useConfirmationModal";
import { unLink } from "../../../DataApi/unlink";
import { useSession } from "../../../authentications/SessionContext";
import TableLoader from "../../Loaders/TableLoader";

const TasklistContainer = styled.div`
width: 98%;
padding: 9px;
background-color: #f8f9fa;
display: flex;
margin: 15px;
border-radius:15px;
justify-content: center;
}
  
`;
const ActionButton = styled.button`
  border-radius: 10px;
  background-color: #ff5837;
  color: #ffffff;
  border: none;
  // width: 80px;
  min-width: 80px;
  height: 30px;
  margin-right: 20px;
`;
const TableContainer = styled.div`
  width: 95%;
  background-color: #fff;
  border-radius: 15px;
  padding: 17px;
  margin: 18px;
  overflow: auto;
  .table tbody tr td,
  .table thead tr th {
    padding: 26px !important;
    font-family: "Inter", sans-serif;
  }

  .table th {
    background-color: #f8f9fa !important;
    padding: 26px !important;
    color: #4e5d78 !important;
    font-family: "Inter", sans-serif;
  }

  tbody tr:hover {
    background-color: #f4f8ff;
  }

  .status {
    background-color: #e5f6ef;
    color: #38cb7c;
    width: 100px;
    height: 30px;
    font-size: 12px;
    text-align: center;
    border-radius: 10px;
    padding: 5px;
  }
`;

const WarehouseTaskList = ({ refetchData }) => {
  const { sessionInfo } = useSession();
  const { company_id, context } = sessionInfo;
  const [selectedRows, setSelectedRows] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);

  const {
    setIsDisabled: setDisableModalButton,
    ConfirmationModal,
    setOpenModal: setOpenConfirmationModal,
  } = useConfirmationModal();
  const { length, inventoryList, loading } = useSelector(
    (state) => state.warehouse
  );
  const indexOfLastItem = currentPage * PAGINATION_DEFAULT_LIMIT;
  const indexOfFirstItem = indexOfLastItem - PAGINATION_DEFAULT_LIMIT;

  const toggleSelectAll = () => {
    if (selectedRows.length === inventoryList.length) {
      setSelectedRows([]);
    } else {
      setSelectedRows(inventoryList.map((record) => record.id));
    }
  };
  const handleDeleteSelection = () => {
    setDisableModalButton(true);

    unLink({
      id: [...selectedRows],
      company_id,
      context,
      model: "stock.picking",
    }).then(() => {
      refetchData({ offset: currentPage * PAGINATION_DEFAULT_LIMIT });
      setSelectedRows([]);
      setOpenConfirmationModal(false);
      setDisableModalButton(false);
    });
  };

  const handleDeleteOrder = () => {
    setOpenConfirmationModal(true);
  };
  const toggleSelectRow = (id) => {
    if (selectedRows.includes(id)) {
      setSelectedRows(selectedRows.filter((rowId) => rowId !== id));
    } else {
      setSelectedRows([...selectedRows, id]);
    }
  };

  const handleChangePage = (value) => {
    setCurrentPage(value);
    refetchData({ offset: (value - 1) * PAGINATION_DEFAULT_LIMIT });
  };

  if (loading === "idle" || loading === "pending") {
    return <TableLoader isLoading={true} />;
  }
  return (
    <>
      <ConfirmationModal
        handleYes={handleDeleteSelection}
        handleNo={() => setOpenConfirmationModal(false)}
      />
      <TasklistContainer>
        <TableContainer>
          <div
            style={{
              height: "64px",
              display: "flex",
              alignItems: "center",
            }}
          >
            {/* {selectedRows?.length === 1 && <ActionButton>Edit</ActionButton>} */}
            {selectedRows.length > 0 && (
              <ActionButton onClick={handleDeleteOrder}>Delete</ActionButton>
            )}
            {selectedRows?.length > 0 && (
              <ActionButton onClick={() => setSelectedRows([])}>
                Clear
              </ActionButton>
            )}
          </div>
          <table className="table">
            <thead>
              <tr>
                <th>
                  <input
                    type="checkbox"
                    checked={selectedRows.length === inventoryList?.length}
                    onChange={toggleSelectAll}
                  />
                </th>
                <th>Reference</th>
                <th>Contact</th>
                <th>Schuduled Date</th>
                <th>Source Document</th>
                <th>Company</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {inventoryList.map((record) => (
                <tr key={record.id}>
                  <td>
                    <input
                      type="checkbox"
                      checked={selectedRows.includes(record.id)}
                      onChange={() => toggleSelectRow(record.id)}
                    />
                  </td>
                  <td>{record.name}</td>

                  <td>{record.partner_id[1]}</td>
                  <td>
                    {moment(record.scheduled_date).format(DISPLAY_DATE_FORMAT)}
                  </td>
                  <td>{record.origin}</td>
                  <td>
                    <div>{record.company_id[1]}</div>
                  </td>
                  <td>
                    <div className="status text-capitalize">{record.state}</div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <div className="pagination-container">
            {/* Pagination Info */}
            <div className="pagination-info">
              {indexOfFirstItem + 1}-
              {Math.min(indexOfLastItem, inventoryList?.length)} of {length}{" "}
              items
            </div>
            {/* Pagination Controls */}
            <div className="pagination-controls">
              <button
                onClick={() => handleChangePage(currentPage - 1)}
                disabled={currentPage === 1}
              >
                &lt;
              </button>
              {/* Page Numbers */}
              <div className="pagination-icons">
                {Array.from(
                  {
                    length: Math.ceil(length / PAGINATION_DEFAULT_LIMIT),
                  },
                  (_, i) => (
                    <button
                      key={i}
                      className={currentPage === i + 1 ? "active" : ""}
                      onClick={() => handleChangePage(i + 1)}
                    >
                      {i + 1}
                    </button>
                  )
                )}
              </div>
              <button
                onClick={() => handleChangePage(currentPage + 1)}
                disabled={
                  currentPage === Math.ceil(length / PAGINATION_DEFAULT_LIMIT)
                }
              >
                &gt;
              </button>
            </div>
          </div>
        </TableContainer>
      </TasklistContainer>
    </>
  );
};

export default WarehouseTaskList;
